import FormService from '../../../core/services/FormService';
import FetchService from '../../../core/services/FetchService';
import { action, extendObservable } from 'mobx';
import UnitItemListService from './UnitItemListService';
import UnitItemListActionsService from './UnitItemListActionsService';
import { isRequired } from '../../../core/validations';
import NotificationService from '../../../core/services/NotificationService';

class MoveUnitItemFormDialogService {
  form = new FormService();
  fetch = new FetchService();
  submit = new FetchService();

  constructor() {
    extendObservable(this, {
      isOpen: false,
    });
    this.unitItemTypes = [];
    this.form.validations = {
      course: [isRequired],
      module: [isRequired],
      unit: [isRequired],
    };
  }

  open = action((courseId, moduleId) => {
    this.isOpen = true;
    this.form.setInitialValues({
      course: courseId,
      module: moduleId,
    });
    this.form.reset();
  });

  handleChange = (path, value) => {
    if (path === 'unit' && value) {
      this.fetch.fetch({ url: `/modules/${this.form.getValue('module')}/units/${value}` }).then((data) => {
        this.unitItemTypes = data.type.itemsType.map((itemType) => itemType.key);
      });
    }
    this.form.setValue(path, value);
  };

  handleConfirm = action(() => {
    const unitItems = UnitItemListService.selectedRows.map((selectedRow) =>
      UnitItemListService.items.find((unitItem) => unitItem.id === selectedRow)
    );
    if (unitItems.some((unitItem) => !this.unitItemTypes.includes(unitItem.item.type.key))) {
      NotificationService.addNotification(
        'At least one selected item type is not allowed in this unit. Choose other unit to continue.',
        'error'
      );
      return;
    }
    this.form.submitted = true;
    if (this.form.errors) {
      return;
    }
    this.submit
      .fetch({
        url: `/units/${this.form.getValue('unit')}/items`,
        method: 'put',
        body: {
          items: unitItems.map((unitItem) => unitItem.item.id),
        },
      })
      .then(() => {
        if (this.submit.data) {
          this.isOpen = false;
          UnitItemListService.selectable = false;
          UnitItemListActionsService.enableShift = false;
          NotificationService.addNotification('Items shifted successfully.', 'success');
          UnitItemListService.load();
          UnitItemListService.selectedRows = [];
        }
        if (this.submit.error) {
          NotificationService.addNotification('Error shifting items.', 'error');
        }
      });
  });

  handleCancel = action(() => {
    this.isOpen = false;
  });
}

const moveUnitFormDialogService = new MoveUnitItemFormDialogService();

export default moveUnitFormDialogService;
